import React from "react";
import { Input, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DSBox from "../../../system-design/DSBox";
import DSPaper from "../../../system-design/DSPaper";
import DSTypography from "../../../system-design/DSTypography";

type CollectionAssetFileInputEmptyProps = {
  fileSpecsText: string;
  acceptedFormats: string;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const CollectionAssetFileInputEmpty = ({
  fileSpecsText,
  acceptedFormats,
  onFileChange,
  disabled = false,
}: CollectionAssetFileInputEmptyProps) => {
  const { spacing, palette } = useTheme();
  return (
    <label
      style={{
        width: "100%",
        cursor: disabled ? "not-allowed" : "pointer",
        display: "block",
      }}
    >
      <DSPaper
        sx={{
          display: "flex",
          flexDirection: "column",
          aspectRatio: "1",
          padding: spacing(4),
          justifyContent: "center",
          alignItems: "center",
          gap: spacing(2),
          alignSelf: "stretch",
          borderRadius: spacing(3),
          border: `2px dashed ${palette.divider}`,
          background: "transparent",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? "none" : "auto",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: disabled ? "transparent" : palette.action.hover,
            borderColor: disabled ? palette.divider : palette.primary.main,
            "& .add-icon": {
              color: disabled ? palette.text.secondary : palette.primary.main,
            },
          },
        }}
      >
        <AddIcon
          className="add-icon"
          sx={{
            color: palette.text.secondary,
            fontSize: "48px",
            transition: "color 0.3s ease",
          }}
        />
        <DSBox
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: spacing(0.5),
          }}
        >
          {fileSpecsText.split("\n").map((line, index) => (
            <DSTypography
              key={index}
              variant="body2"
              sx={{
                color: palette.text.secondary,
                textAlign: "center",
              }}
            >
              {line}
            </DSTypography>
          ))}
        </DSBox>
        <Input
          inputProps={{ accept: acceptedFormats }}
          type="file"
          onChange={onFileChange}
          disabled={disabled}
          style={{
            display: "none",
          }}
        />
      </DSPaper>
    </label>
  );
};

export default CollectionAssetFileInputEmpty;
